export default "__VITE_ASSET__2f431a3f__"